import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowBack, Search, Close } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';

type Foto = {
  uid_pesca_foto: string;
  url: string;
  legenda?: string | null;
  syn_cadmom: string;
  pescador?: { uid_pesca_pescador: string; nome: string } | null;
};

const Galeria = () => {
  const navigate = useNavigate();
  const [fotos, setFotos] = useState<Foto[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [tempSearch, setTempSearch] = useState("");
  const [search, setSearch] = useState("");
  const [fotoAmpliada, setFotoAmpliada] = useState<Foto | null>(null);

  const fetchFotos = useCallback((searchTerm: string) => {
    setLoading(true);
    api.get('/pesca/fotos', { params: { search: searchTerm, limit: 60 } })
      .then(res => {
        setFotos(res.data.data);
        setTotal(res.data.total || 0);
      })
      .finally(() => setLoading(false));
  }, []);

  // Debounce da busca, mesmo padrão das outras telas
  useEffect(() => {
    const handler = setTimeout(() => setSearch(tempSearch), 500);
    return () => clearTimeout(handler);
  }, [tempSearch]);

  useEffect(() => {
    fetchFotos(search);
  }, [search, fetchFotos]);

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Galeria de Fotos</h1>

        <div style={{ position: 'relative', flex: 1, maxWidth: '400px', margin: '0 20px' }}>
          <Search style={{ position: 'absolute', left: '10px', top: '10px', color: '#888' }} />
          <input
            type="text"
            placeholder="Pesquisar por pescador..."
            value={tempSearch}
            onChange={(e) => setTempSearch(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 10px 10px 40px',
              borderRadius: '20px',
              border: '1px solid #ddd',
              outline: 'none'
            }}
          />
        </div>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{total}</span>
          </p>
          <button className={styles.blueBtn} onClick={() => navigate(-1)} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      {loading ? (
        <p style={{ color: '#666' }}>Carregando fotos...</p>
      ) : fotos.length === 0 ? (
        <p style={{ color: '#999', textAlign: 'center', padding: '40px 0' }}>
          Nenhuma foto encontrada. Fotos enviadas pelos pescadores via WhatsApp aparecem aqui.
        </p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '16px',
          }}
        >
          {fotos.map((foto) => (
            <div
              key={foto.uid_pesca_foto}
              onClick={() => setFotoAmpliada(foto)}
              style={{
                background: '#fff',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ width: '100%', aspectRatio: '1 / 1', background: '#f0f0f0', overflow: 'hidden' }}>
                <img
                  src={foto.url}
                  alt={foto.legenda || 'Foto de pescaria'}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div style={{ padding: '10px 12px' }}>
                <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#222' }}>
                  {foto.pescador?.nome || 'Pescador não identificado'}
                </div>
                {foto.legenda && (
                  <div
                    style={{
                      fontSize: '0.78rem', color: '#777', marginTop: '2px',
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                  >
                    {foto.legenda}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {fotoAmpliada && (
        <div
          onClick={() => setFotoAmpliada(null)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '20px',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', overflow: 'hidden',
              maxWidth: '90vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
              <Close style={{ cursor: 'pointer' }} onClick={() => setFotoAmpliada(null)} />
            </div>
            <img
              src={fotoAmpliada.url}
              alt={fotoAmpliada.legenda || 'Foto de pescaria'}
              style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
            />
            <div style={{ padding: '12px 16px 16px' }}>
              <div style={{ fontWeight: 600 }}>{fotoAmpliada.pescador?.nome || 'Pescador não identificado'}</div>
              {fotoAmpliada.legenda && <div style={{ color: '#666', marginTop: '4px' }}>{fotoAmpliada.legenda}</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Galeria;
